module.exports = __webpack_public_path__ + "static/media/cardiff-uni.cd4f4d6e.svg";